
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import apiUrl from "../../environment/Api";
import { useNavigate } from "react-router-dom";

import "../../assets/css/Staffpayslip.css";

function Staff_payslip() {
    const [staffdata, setstaffdata] = useState([]);
    const navigate = useNavigate();




    useEffect(() => {
        staffed();
        const timeoutId = setTimeout(() => {
            window.print();
        }, 2000);



        const redirectTimeoutId = setTimeout(() => {
            navigate("/salary");
        }, 2000);



        return () => {
            clearTimeout(timeoutId);
            clearTimeout(redirectTimeoutId);
            // clearTimeout(pdfTimeoutId);
        };
    }, [navigate])

    const staffed = async () => {
        try {

            const response = await axios.get(apiUrl + `/staff`);
            setstaffdata(response.data);
            console.log("the response data  staff ", response.data)
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };



    const currentDate = new Date();
    const monthNames = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];
    const currentMonth = monthNames[currentDate.getMonth()];
    const currentYear = currentDate.getFullYear();



    return (
        <div className='main'>

            {/* the logo image  */}
            <div className='row'>
                <div className='col-lg-3'></div>
                <div className='col-lg-6'>
                    <div style={{ width: "80%" }}>
                        <img
                            alt="invoice logo"
                            style={{
                                width: "100%",
                                height: '70px',
                                marginLeft: "35px",
                                // marginTop: "10px",
                            }}
                            src={require("../../assets/img/scimitar logo slogan.png")}
                        />
                    </div>
                </div>
                <div className='col-lg-3'></div>
            </div>
            {/* the address */}
            <div className='first_para row'>
                <div className='col-lg-3'></div>
                <div className='col-lg-6'>
                    <h2 className='address'><b>GH Backside, 29/30 Pavadai St, Kaikolar Thottam, Erode-638001</b></h2>

                    <h2 className='address'><b>PAY SLIP FOR THE MONTH {currentMonth} - {currentYear}</b></h2>
                </div>
                <div className='col-lg-3'></div>

            </div>

            {/* <p className='linee' ></p> */}

            {/* details */}

            <div className='firstcard' style={{ display: 'flex', justifyContent: 'space-between' }}>

                <div className='centerline'>
                    <div className='details' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-1px' }}>
                        <h2 className='details_name'>Employee </h2>
                        <p className='dot'> : </p>
                        <p className='details_data' style={{ justifyContent: 'space-between' }}>{staffdata[0]?.name}</p>
                    </div>

                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>Date Of Joining</h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>{staffdata[0]?.name}</p>
                    </div>

                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>Employee Code </h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>{staffdata[0]?.empid}</p>
                    </div>

                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>Designation</h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>{staffdata[0]?.designation[0]?.designation}</p>
                    </div>
                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>ESI Account Number</h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>123456789101111</p>
                    </div>
                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>PF UAN Number</h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>123456789101111</p>
                    </div>

                    <div className='' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h2 className='details_name'>PF ACC Number</h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>123456789101111</p>
                    </div>

                </div>

                <div className='detailsed' style={{ display: 'flex', justifyContent: 'space-between' }}>

                    <div>
                        <div className='details' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1px' }}>
                            <h2 className='details_name'>Department</h2>
                            <p className='dot'> :</p>
                            <p className='details_data'>{staffdata[0]?.designation[0]?.department}</p>
                        </div>

                        <div className='' style={{ display: 'flex', justifyContent: 'space-around' }}>
                            <h2 className='details_name'>Branch</h2>
                            <p className='dot'> :</p>
                            <p className='details_data'>{staffdata[0]?.branch_id[0]?.branch_name}</p>
                        </div>

                        <div className='firstcard'>
                            <h6 className='para'> Company Working Days : 23</h6>

                            <h6 className='para'> Day  Working By Employee : 23</h6>
                        </div>

                    </div>




                </div>
            </div>

            {/* line */}
            {/* <p className='line'></p> */}
            <div className='salary'>
                <h1><b>Salary Break Up</b></h1>
            </div>
            <p className='linee'></p>
            {/* ================================ */}
            <div className='firstcardd' style={{ display: 'flex' }}>
                <div>
                    <div className='titleone' style={{ display: 'flex', marginTop: '-10px' }}>
                        <h2 className='details_name'>Earnings </h2>

                        <h2 className='amount'>Amount</h2>
                    </div>
                </div>

                <div className='detailsed' style={{ display: 'flex', marginTop: '-20px' }}>
                    <div className='title' style={{ display: 'flex' }}>
                        <h2 className='details_name'>Deduction </h2>

                        <h2 className='amount'>Amount</h2>
                    </div>
                </div>
            </div>



            <div className='firstcardd' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-10px' }}>
                <div>
                    <div className='details' style={{ display: 'flex', }}>
                        <h2 className='details_name'>Basic Pay </h2>
                        <p className='dot'> :</p>
                        <p className='details_data' style={{ marginLeft: '50px' }} >{staffdata[0]?.salary}</p>
                    </div>

                    <div className='' style={{ display: 'flex' }}>
                        <h2 className='details_name'>HRA </h2>
                        <p className='dot'> :</p>
                        <p className='details_data' style={{ marginLeft: '80px' }}>4700.00</p>
                    </div>

                    <div className='' style={{ display: 'flex' }}>
                        <h2 className='details_name'>Special Allowance </h2>
                        <p className='dot'> :</p>
                        <p className='details_data' style={{ marginLeft: '3px' }}>8000.00</p>
                    </div>

                    <div className='' style={{ display: 'flex' }}>
                        <h2 className='details_name'>Incentive </h2>
                        <p className='dot'> :</p>
                        <p className='details_data' style={{ marginLeft: '50px' }}>20000.00</p>
                    </div>


                </div>


                <div className='detailsed' style={{ display: 'flex', justifyContent: 'space-between' }}>

                    <div>

                        <div className='details' style={{ display: 'flex' }}>
                            <h2 className='dedux'>EPF</h2>
                            <p className='dot'> :</p>
                            <p className='dedux'>00</p>
                        </div>

                        <div className='' style={{ display: 'flex' }}>
                            <h2 className='dedux'>EPF</h2>
                            <p className='dot'> :</p>
                            <p className='dedux'>00</p>
                        </div>

                    </div>
                </div>
            </div>

            {/* <p className='line'></p> */}

            <div className='firstcardd' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-10px' }}>
                <div>
                    <div className='details' style={{ display: 'flex' }}>
                        <h2 className='details_name'>Total Earnings </h2>
                        <p className='dot'> :</p>
                        <p className='details_data'>40000.00</p>
                    </div>

                </div>


                <div className='detailsed' style={{ display: 'flex', justifyContent: 'space-between' }}>

                    <div>
                        <div className='' style={{ display: 'flex', marginTop: '20px', marginBottom: '-5px' }}>
                            <b><h2 className='dedux'>Total Deduction</h2></b>
                            <p className='dot'> :</p>
                            <p className='amountdedux'>00</p>
                        </div>


                    </div>
                </div>
            </div>
            {/* 
            <p className='underline'></p> */}


            <div className='netsalary'>
                <div className='details' style={{ display: 'flex' }}>
                    <b><h2 className='deduxing'>Net Salary Payable </h2></b>
                    <p className='dot'> :</p>
                    <p className='deduxed'>00</p>
                </div>
            </div>

            <p className='underline'></p>

        </div>
    )
}


export default Staff_payslip